/* eslint-disable no-console */
/* eslint-disable consistent-return */

import getAccessToken from '../../utils/getAccessToken'
import { getDomain } from '../../utils/browser'

export const CHECK_CONCURRENT_STREAM_REQUEST = 'CHECK_CONCURRENT_STREAM_REQUEST'
export const CHECK_CONCURRENT_STREAM_SUCCESS = 'CHECK_CONCURRENT_STREAM_SUCCESS'
export const CHECK_CONCURRENT_STREAM_FAILURE = 'CHECK_CONCURRENT_STREAM_FAILURE'
export const CLEAR_CONCURRENT_STREAM = 'CLEAR_CONCURRENT_STREAM'
const domain = getDomain()
const apiRequest = async ({
  url = `https://hawkeye${domain}/pusher/rest`, method, body = null, token = null,
}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  }
  const options = { method, headers, ...(body && { body: JSON.stringify(body) }) }
  const response = await fetch(url, options)
  if (!response.ok) {
    throw new Error(`API Error: Failed to fetch Concurrent stream`)
  }
  return response.json()
}

export const checkConcurrentStreamRequest = () => ({
  type: CHECK_CONCURRENT_STREAM_REQUEST,
})

export const checkConcurrentStreamSuccess = payload => ({
  type: CHECK_CONCURRENT_STREAM_SUCCESS,
  payload,
})

export const checkConcurrentStreamFailure = error => ({
  type: CHECK_CONCURRENT_STREAM_FAILURE,
  payload: error,
})

export const clearConcurrentStream = (payload = {}) => ({
  type: CLEAR_CONCURRENT_STREAM,
  payload,
})

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

let currentHeartbeatInterval = null

// eslint-disable-next-line max-len
export const checkConcurrentStream = (isDelete, channel, sportsExclusive, isRetry) => async (dispatch) => {
  dispatch(checkConcurrentStreamRequest())

  // Clear any existing heartbeat interval
  if (currentHeartbeatInterval) {
    clearInterval(currentHeartbeatInterval)
    currentHeartbeatInterval = null
  }

  try {
    const previousSessionId = sessionStorage.getItem('stv_concurrent_session_id')
    const previousChannel = sessionStorage.getItem('stv_concurrent_channel')

    const accessToken = await getAccessToken()
    // Always attempt to delete the previous session if it exists
    if (previousSessionId) {
      const deleteBody = {
        stream: previousChannel,
        session_id: previousSessionId,
      }
      await apiRequest({ method: 'DELETE', body: deleteBody, token: accessToken })
        .then((res) => {
          if (res.delete === true) {
            sessionStorage.removeItem('stv_concurrent_session_id')
            sessionStorage.removeItem('stv_concurrent_channel')
          }
        })
        .catch((deleteError) => {
          console.error('Error deleting previous session:', deleteError)
        })
    }
    if (isDelete) return

    // proceed only if isDelete is false
    if (isRetry) {
      await delay(5000) // 5 second delay for retry
    }

    if (!sportsExclusive) {
      dispatch(clearConcurrentStream({ loading: false }))
      return false
    }

    // creating a new session
    const newSessionBody = {
      stream: channel,
      session_id: null, // New session, so no session_id yet
    }

    const data = await apiRequest({ method: 'POST', body: newSessionBody, token: accessToken })

    if (data.access === 'granted') {
      sessionStorage.setItem('stv_concurrent_session_id', data.session_id)
      sessionStorage.setItem('stv_concurrent_channel', channel)
      dispatch(
        checkConcurrentStreamSuccess({
          showModal: false,
          sessionId: data.session_id,
          playbackUrl: data.playback_url,
          channel,
        }),
      )

      // Heartbeat every 30 sec
      currentHeartbeatInterval = setInterval(async () => {
        try {
          const refreshBody = {
            stream: channel,
            session_id: data.session_id,
          }
          const intervalData = await apiRequest({ method: 'PUT', body: refreshBody, token: accessToken })
          console.log('Session refreshed')
          if (intervalData.access === 'denied') {
            dispatch(checkConcurrentStreamSuccess({
              showModal: true, sessionId: null, playbackUrl: null, channel: null,
            }))
            clearInterval(currentHeartbeatInterval)
            currentHeartbeatInterval = null
          }
        } catch (heartbeatError) {
          console.error('Error refreshing session:', heartbeatError)
          clearInterval(currentHeartbeatInterval)
          currentHeartbeatInterval = null
        }
      }, 30000)
    } else {
      dispatch(checkConcurrentStreamSuccess({
        showModal: true, sessionId: null, playbackUrl: null, channel: null,
      }))
    }

    return data.access === 'denied'
  } catch (error) {
    console.error('Error checking concurrent stream:', error)
    dispatch(checkConcurrentStreamFailure(error))
    return false
  }
}
